<template>
    <div class="px-4 pb-3">
        <div class="flex wrapper-coupon p-2 lg:px-6 lg:py-2.5">
            <img class="ml-0 mr-2 lg:mr-3 mt-0 mb-auto" v-if="isPointNotEnough" src="@/assets/icon/ic-coupon-brown.svg" />
            <img class="ml-0 mr-2 lg:mr-3 mt-0 mb-auto" v-else src="@/assets/icon/ic-coupon-green.svg" />
            <div class="coupon ml-0 my-auto">
                <div class="campaign-name font-bold text-14 lg:text-16 pr-2 text-a-brown-502314"
                    :class="{'text-a-brown-9f8273': isPointNotEnough}">{{campaign.name}}</div>
                <div class="text-14 lg:text-16 text-a-brown-9f8273">{{getPointMessage()}}</div>
                <div @click="showCondition()" class="pt-1 text-12 text-a-red-d62300 cursor-pointer">{{lbl.coupon.condition}}</div>
            </div>
            <div v-if="!isPointNotEnough" class="ml-0 mt-2 lg:mt-4 text-14 lg:text-16 text-a-red-d62300 cursor-pointer" @click="clickGetCoupon()">{{lbl.coupon.use_now}}</div>
        </div>
        <div v-if="isPointNotEnough" class="px-2 pt-1 pb-2 lg:px-4 text-10 lg:text-12 text-a-red-d14545 ">
            {{getError()}}
        </div>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
import BzbsCoupon from "@/core/Coupon/service/BzbsCoupon";
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/config/CampaignConfigModel';
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
/**
 * @event onRedeemCoupon
 */
export default {
    name: 'CouponItem',
    inject: ['PlaceOrderStore'],
    mixins: [ModalMixin,LocaleMixin,AuthStatusMixin],
    components: {
    },
    computed: {
        isPointNotEnough: function() {
            return this.userPoint < this.campaign.pointPerUnit
        },
    },
    props: {
        campaign:     { type: Object, required: true },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.lbl.coupon.use
            var pointUnit = this.lbl.coupon.crown_point;
            return pointType + " " + this.FilterNumberFormat(this.campaign.pointPerUnit) + " " + pointUnit;
        },
        clickGetCoupon: function() {
            this.modal.confirmCouponModal.clearModal()
                                        .setCampaign(this.campaign)
                                        .setBtnOk(this.lbl.coupon.popup_confirm.confirm)
                                        .show();
            this.modal.confirmCouponModal.onClickOk(()=> {
                this.modal.loadingModal.show();
                let label = "shopping_bag|" + this.campaign.id + "|" + this.campaign.name;
                this.tracking.event('shopping_bag','click_used_coupon', label, null);
                BzbsCoupon.redeemCoupon(this.campaign.id).subscribe({
                    next: (data) => {
                        this.campaign.setCode(data.data.Code);
                        this.campaign.setCodeType(data.data.CodeType);
                        this.campaign.setType(data.data.Type);
                        this.modal.loadingModal.hide();
                        this.redeemSuccess();
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                    },
                })
            })
            
        },
        redeemSuccess: function() {
            this.PlaceOrderStore.state.placeOrder.coupon = {...this.campaign};
            this.PlaceOrderStore.methods.updatePlaceOrder();
            this.apiUpdateProfile();
            this.$emit('onRedeemCoupon');
        },
        getError: function() {
            return Util.stringFormat(this.lbl.coupon.warning_point_not_enough,this.FilterNumberFormat(this.campaign.pointPerUnit))
        },
        showCondition: async function() {
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaign.id)
                .create();
            this.modal.loadingModal.show();
            this.campaignDeteil = await this.getCampaignDetail(this.campaignConfig);
            this.modal.loadingModal.hide();
            if (this.campaignDeteil) {
                this.modal.conditionCouponModal.clearModal()
                                .setMsg(this.lbl.coupon.popup_condition.coupon + this.campaignDeteil.name)
                                .setMsg2(this.campaignDeteil.condition)
                                .show();
            }
            
        },
        getCampaignDetail: function(campaignConfig) {
            return new Promise((resolve) => {
                BzbsCampaign.apiGetCampaignDetail(campaignConfig).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        this.errorApi(err);
                    },
                });
            });
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/text.scss";
    .wrapper-coupon {
        background-image: url('../../../assets/image/bg-coupon-mobile_new.svg');
        background-position: center;
        background-size: 100%;
        background-repeat: repeat-y;
        background-position-y: -5px;
        
        @include min-desktop {
            background-image: url('../../../assets/image/bg-coupon.svg');
         
        }

        .coupon {
            width: calc(100% - 125px);

            @include min-desktop {
                width: calc(100% - 130px);
            }
            .campaign-name {
                @extend %ellipsis-2;
            }
        }
    }
    
    
</style>
